export const GET_SETS = 'GET_SETS';
export const GET_SETS_SUCCESS = 'GET_SETS_SUCCESS';
export const GET_SETS_ERROR = 'GET_SETS_ERROR';

export const CLEAR_SETS = 'CLEAR_SETS';
